import React, { useRef, useEffect } from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

import { useListViewed as usePromoListViewed } from '~/techstyle-shared/react-components';

import DefaultMarketingCard from '../DefaultMarketingCard';
import VIPHomepageMarketingCard from '../VIPHomepageMarketingCard';

const PromoMarketingCardWrapper = styled.div``;

function MarketingCard({
  cardVariant,
  asset,
  index,
  mobileCardLayout,
  gender,
  refs,
}) {
  const { observe, unobserve } = usePromoListViewed();
  const assetRef = useRef(null);

  useEffect(() => {
    const node = assetRef.current;
    if (node) {
      observe(node, asset);
      return () => unobserve(node);
    }
  }, [observe, unobserve, asset]);

  switch (cardVariant) {
    case 'VIPHomepage':
      return (
        <PromoMarketingCardWrapper ref={assetRef}>
          <VIPHomepageMarketingCard
            asset={asset}
            index={index}
            mobileCardLayout={mobileCardLayout}
            gender={gender}
            refs={refs}
          />
        </PromoMarketingCardWrapper>
      );
    default:
      return (
        <PromoMarketingCardWrapper ref={assetRef}>
          <DefaultMarketingCard
            ref={assetRef}
            asset={asset}
            variant={cardVariant}
            index={index}
            gender={gender}
            refs={refs}
          />
        </PromoMarketingCardWrapper>
      );
  }
}

MarketingCard.propTypes = {
  asset: PropTypes.object,
  cardVariant: PropTypes.string,
  gender: PropTypes.string,
  index: PropTypes.number,
  mobileCardLayout: PropTypes.string,
  refs: PropTypes.object,
};

export default MarketingCard;
